<template>
  <InfoMessage
    icon="confetti"
    :title="$t('aeskulab.form.thankYou.title')"
    :perex="$t('aeskulab.form.thankYou.perex')"
    width="492"
    class="mx-auto"
    :show-close="false"
  >
    <template #body>
      <div class="grey rounded pa-4">
        <label v-html="$t('dashboard.personalInfoAssurance.prefix')" />
        <div class="text-body-small">
          {{ $t('dashboard.personalInfoAssurance.email') }}: <strong>{{ queryData.email }}</strong>
        </div>
        <div class="text-body-small">
          {{ $t('dashboard.personalInfoAssurance.phone') }}:
          <strong>{{ queryData.phoneNumber }}</strong>
        </div>
      </div>
    </template>
  </InfoMessage>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AeskulabThankYou',
  computed: {
    ...mapGetters({
      queryData: 'aeskulab/queryData'
    })
  }
};
</script>
